module.exports = __webpack_public_path__ + "img/29_11.1c50ec35.png";